<template>
    <b-card>
        <div slot="header">{{ $t('label.account') }}</div>
        <b-form-group>
            <label>{{ $t('label.username') }}</label>
            <b-form-input
                disabled
                type="text"
                :textarea="true"
                :placeholder="$t('label.username')"
                v-model="user.email"
            ></b-form-input>
        </b-form-group>
        <b-form-group>
            <label>{{ $t('label.alternateUsername') }}</label>
            <b-form-input
                disabled
                type="text"
                :textarea="true"
                :placeholder="$t('label.username')"
                v-model="user.username"
            ></b-form-input>
        </b-form-group>

        <b-form-group v-if="usertypes.length > 0">
            <label>{{ $t('label.usertype') }}</label>
            <multiselect
                :disabled="!canEdit || !isManager"
                :value="user.usertype"
                @select="usertypeChanged"
                :options="usertypes"
                label="name"
                selectLabel
                deselectLabel
                track-by="id"
                :allowEmpty="true"
            >
                <!-- <template slot="singleLabel" slot-scope="props">
                    <span class="option__desc">
                        <div class="option__title">{{ props.option.name }}</div>
                        <div class="option__small" style="font">{{ props.option.description }}</div>
                    </span>
                </template>-->
                <template style="width: 100%" slot="option" slot-scope="props">
                    <div class="option__desc">
                        <div
                            class="option__title"
                            style="font-weight: bold; margin-bottom: 10px"
                        >
                            {{ props.option.name }}
                        </div>
                        <div
                            class="option__small"
                            style="white-space: pre-wrap"
                        >
                            {{ props.option.description }}
                        </div>
                    </div>
                </template>
            </multiselect>
        </b-form-group>

        <b-button-group v-if="canEdit && isManager">
            <!-- Password reset -->
            <a-button :disabled="!canEdit" @click="onPasswordReset()">
                <i class="fa fa-dot-circle-o" v-if="!user.saving"></i>
                <i class="fa fa-spinner fa-spin" v-if="user.saving"></i>
                <span>{{ $t('text.resetPassword') }}</span> </a-button
            >&nbsp;
            <a-popconfirm
                v-if="user.id != authUser.id"
                :title="$t('confirm.delete')"
                @confirm="deleteuser()"
            >
                <a-button
                    type="danger"
                    class="pull-right"
                    :title="$t('label.confirm')"
                >
                    <i class="fa fa-ban"></i>
                    &nbsp;
                    <span>&nbsp;{{ $t('label.delete') }}</span>
                </a-button> </a-popconfirm
            >&nbsp;
            <!-- Delete -->
            <!-- <b-btn
                :disabled="user.saving || !canEdit"
                @click="deleteuser()"
                size="sm"
                variant="danger"
            >
                <i class="fa fa-ban"></i>
                {{ $t('label.delete') }}
            </b-btn>-->

            <!-- Impersonate -->
            <a-button
                variant="warning"
                :disabled="!canEdit"
                v-if="canImpersonate && user.id != authUser.id"
                @click="$store.dispatch('auth/impersonate', user.id)"
            >
                <!-- TODO: theater-masks -->
                <i class="fa fa-theater-masks"></i>
                {{ $t('label.impersonate') }}
            </a-button>
        </b-button-group>
    </b-card>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import get from 'lodash/get'

export default {
    props: {
        user: {
            required: true,
        },
        canEdit: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            company: this.$resource('companies', {
                id: this.user.company_id,
            }),
        }
    },

    created() {
        this.company.setIncludes('usertypes')
        this.company.fetch()
    },

    methods: {
        ...mapActions({
            impersonate: 'auth/impersonate',
        }),

        usertypeChanged(usertype) {
            // this.user.usertype = usertype
            // this.user.usertype_id = usertype.id
            console.log('usertypeChanged', usertype)

            this.$emit('change', {
                usertype_id: usertype.id,
                usertype,
            })
        },

        deleteuser() {
            let that = this

            this.user.delete().then(() => {
                alert(that.$t('label.deleted'))
                that.$router.push(
                    '/organization/' + that.$route.params.orgId + '/users'
                )
            })
        },

        onPasswordReset() {
            if (!this.user.mobile_phone) {
                alert(
                    'Please add a mobile phone number that can receive sms to use this feature'
                )
                return
            }

            if (!confirm('Are you sure you want to reset the password?')) {
                return
            }

            if (!this.user.mobile_phone) {
                alert(
                    'Please add a mobile phone number that can receive sms to use this feature'
                )
                return
            }

            if (!confirm('Are you sure you want to reset the password?')) {
                return
            }

            /// Todo: Put this in service!
            this.$http
                .post('resource/users/' + this.user.id + '/passwordreset')
                .then(res => {
                    if (get(res, 'data.message', false)) {
                        alert(res.data.message)
                    }

                    if (get(res, 'response.data.message', false)) {
                        alert(res.response.data.message)
                    }
                })
                .catch(() => {
                    alert('An error occured. Please try again')
                })
        },
    },

    computed: {
        ...mapGetters({
            impersonating: 'auth/isImpersonating',
            canImpersonate: 'auth/canImpersonate',
            authUser: 'auth/user',
            isManager: 'auth/isManager',
        }),

        usertypes() {
            let company = this.company

            if (company.loading) {
                return []
            }

            return company.usertypes
        },
    },
}
</script>
